import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'as2005',
    ecrans: ['00-2'],
    params:['?ramcleint',
            '?madcleint',
            '?stamnetab']
});
